import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';

import Config from '../config';

const env = process.env.GATSBY_ENV;

const SEO = ({
  children,
  description,
  meta,
  title,
  pathname,
  image,
  keywords,
  noindex,
}) => {

  const intl = useIntl();
  const lang = intl.locale;

  const metaDescription = description || Config.siteMetadata.description;
  const siteUrl = `${Config.siteMetadata.siteUrl}/${lang}${pathname}`;
  const thumbnail = image || Config.siteMetadata.defaultImage;
  const metaKeywords = `${Config.siteMetadata.keywords},${(keywords || '')}`;

  return (
    <Helmet
      titleTemplate={`%s | ${Config.siteMetadata.title}`}
    >
      <html lang={lang} />
      <title>{title}</title>
      <meta name="title" content={`${title} | ${Config.siteMetadata.title}`} />
      <meta name="description" content={metaDescription} />
      <meta name="author" content="Mentorshow Limited" />
      <meta property="keywords" content={metaKeywords} />

      <meta property="og:title" content={`${title} | ${Config.siteMetadata.title}`} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MentorShow" />
      <meta property="og:image" content={thumbnail} />
      <meta property="og:image:secure_url" content={thumbnail} />
      <meta property="og:image:width" content={1200} />
      <meta property="og:image:height" content={730} />
      <meta property="og:locale" content={lang} />
      <meta property="og:url" content={siteUrl} />
      <meta property="fb:app_id" content={Config.siteMetadata.fbAppId} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={`${title} | ${Config.siteMetadata.title}`} />
      <meta name="twitter:creator" content={Config.siteMetadata.author} />
      <meta name="twitter:description" content={metaDescription} />

      <meta name="wot-verification" content="8504e6b6713026e3be16" />

      <meta name="robots" content={!noindex && env === 'production' ? 'index, follow' : 'noindex'} />

      <link rel="canonical" href={siteUrl} />
      <link rel="alternate" hrefLang="x-default" href={siteUrl} />
      {Config.supportedLocales.map((locale) => (
        <link key={locale} rel="alternate" hrefLang={locale} href={`${Config.siteMetadata.siteUrl}/${locale}${pathname}`} />
      ))}

      {children}
    </Helmet>
  );
};

SEO.defaultProps = {
  children: null,
  meta: [],
  description: '',
  image: null,
  pathname: '',
  keywords: '',
  noindex: false,
};

SEO.propTypes = {
  children: PropTypes.any,
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  pathname: PropTypes.string,
  keywords: PropTypes.string,
  noindex: PropTypes.bool,
};

export default SEO;
